import React, { useEffect, useState } from "react";
import { Col, Row, Typography, Button, Form, Input, Modal } from "antd";
import nibbleslogo from "../../asset/nibbleslogo.jpg";
import "./onboarding.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAuthReducer } from "../../redux/Reducer/authReducer";
import { getSignin, googleSignIn, verify2FALogin } from "../../redux/Actions"; // Imported verify2FALogin
import { GoogleIcon } from "../../asset/icons/icons";
import { useGoogleLogin } from "@react-oauth/google";

const { Text } = Typography;

export default function SignIn() {
  const navigate = useNavigate();
  // 👉 ADDED 2FA states from Redux
  const { authUser, isLoading, requires2FA, tempToken, isVerifying2FALogin } =
    useSelector(getAuthReducer);
  const dispatch = useDispatch();

  const [signindetails, setSigninDetails] = useState({
    email: "",
    password: "",
  });
  const [signinErrors, setSigninErrors] = useState({ email: "", password: "" });
  const [form] = Form.useForm();

  // 👉 ADDED Local states for 2FA Modal
  const [is2FAModalOpen, setIs2FAModalOpen] = useState(false);
  const [otpCode, setOtpCode] = useState("");

  const formLayout = { labelCol: { span: 24 }, wrapperCol: { span: 24 } };

  // Automatically open modal when backend says 2FA is required
  useEffect(() => {
    if (requires2FA && tempToken) {
      setIs2FAModalOpen(true);
    }
  }, [requires2FA, tempToken]);

  const handle2FASubmit = () => {
    if (!otpCode || otpCode.length < 6) return;
    dispatch(verify2FALogin({ temp_token: tempToken, otp: otpCode }));
  };

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;
    setSigninDetails({ ...signindetails, email: emailInput });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailInput || !emailRegex.test(emailInput)) {
      setSigninErrors((prev) => ({
        ...prev,
        email: "Please enter a valid email address.",
      }));
    } else {
      setSigninErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const handlePasswordChange = (e) => {
    const passwordInput = e.target.value;
    setSigninDetails({ ...signindetails, password: passwordInput });
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    if (!passwordInput || !passwordRegex.test(passwordInput)) {
      setSigninErrors((prev) => ({
        ...prev,
        password:
          "Password must be at least 6 chars, include a symbol, upper/lowercase, and a digit.",
      }));
    } else {
      setSigninErrors((prev) => ({ ...prev, password: "" }));
    }
  };

  const handleSignInUser = () => {
    dispatch(getSignin(signindetails));
  };

  // Redirect Logic
  useEffect(() => {
    if (authUser && authUser?.message === "Login successful!") {
      if (authUser?.user?.email_verified_at === null) {
        navigate("/enterotp");
        return;
      }
      if (authUser?.user.gender === null) {
        if (
          authUser?.user.user_type_id === 1 ||
          (authUser?.user.user_type_id === 2 && authUser?.user.status === 1)
        ) {
          navigate("/admindashboard");
        } else if (authUser?.user.user_type_id === 5) {
          navigate("/dashboard");
        } else if (
          authUser?.user.user_type_id === 2 &&
          authUser?.user?.status === 0
        ) {
          navigate("/changePassword");
        } else {
          navigate("/onboarding");
        }
      } else if (
        authUser?.user.user_type_id === 1 ||
        authUser?.user.user_type_id === 2
      ) {
        navigate("/admindashboard");
      } else if (authUser?.user.user_type_id === 4) {
        navigate("/retaildashboard");
      } else {
        navigate("/dashboard");
      }
    }
  }, [authUser, navigate]);

  const login = useGoogleLogin({
    onSuccess: (response) => dispatch(googleSignIn(response.access_token)),
    onError: (error) => console.log("Login Failed:", error),
  });

  return (
    <>
      <Row>
        <Col
          xs={{ span: 24 }}
          lg={{ span: 12 }}
          className="getstartedbackground"
        ></Col>

        <Col
          xs={{ span: 24 }}
          lg={{ span: 12 }}
          className="getstartefirstrowlogo"
        >
          <Row className="getstartedrowlogo">
            <Col span={24} className="getstartedcollogo">
              <img alt="nibbleslogo" src={nibbleslogo} />
            </Col>
          </Row>

          <Row>
            <Col span={24} className="getstartedcolpad">
              <p
                className="typography getstartedtext"
                style={{ marginBottom: "0px" }}
              >
                Get Started
              </p>
              <Text className="joinbakery typography">
                Join our bakery's community of happy customers. Sign up today!
              </Text>
            </Col>

            <Col span={24} className="getstartedcolpad">
              <Form
                {...formLayout}
                form={form}
                size={"large"}
                className="typography"
              >
                <Col xs={{ span: 24 }}>
                  <Form.Item
                    label={
                      <label className="typography fw-bold">
                        Email Address
                      </label>
                    }
                    name="email"
                  >
                    <Input
                      type="email"
                      value={signindetails.email}
                      onChange={handleEmailChange}
                    />
                  </Form.Item>
                  {signinErrors.email && (
                    <p className="error typography">{signinErrors.email}</p>
                  )}
                </Col>

                <Col xs={{ span: 24 }}>
                  <Form.Item
                    label={
                      <label className="typography fw-bold">
                        Password <span style={{ color: "red" }}>*</span>
                      </label>
                    }
                    name="password"
                  >
                    <Input.Password
                      type="password"
                      value={signindetails.password}
                      onChange={handlePasswordChange}
                    />
                  </Form.Item>
                  {signinErrors.password && (
                    <p className="error typography">{signinErrors.password}</p>
                  )}

                  <p className="typography text-end mb-4">
                    <Link
                      to={"/forgotpassword"}
                      style={{ textDecoration: "none", color: "#252A4D" }}
                    >
                      Forgot Password?
                    </Link>
                  </p>
                </Col>

                <Col xs={{ span: 24 }}>
                  <Button
                    onClick={handleSignInUser}
                    className="signupbutton typography"
                    disabled={
                      !signindetails.password ||
                      !signindetails.email ||
                      signinErrors.email ||
                      signinErrors.password ||
                      isLoading
                    }
                    block
                  >
                    {isLoading ? "Loading..." : "Sign In"}
                  </Button>
                </Col>
              </Form>
            </Col>
          </Row>

          <Row>
            <Col span={24} className="getstartedcolpad">
              <Button
                block
                size={"large"}
                className="buttonicons typography justify-content-center"
                onClick={() => login()}
              >
                <p>
                  <GoogleIcon />{" "}
                  <span style={{ marginLeft: "1em" }}>Sign in with Google</span>
                </p>
              </Button>
            </Col>
          </Row>

          <Row>
            <Col span={24} className="getstartedcolpad">
              <Text className="joinbakery typography">
                Don't have an account?{" "}
                <Link
                  to={"/signup"}
                  style={{ color: "#998C16", textDecoration: "underline" }}
                >
                  Sign Up
                </Link>
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* 👉 2FA OTP MODAL */}
      <Modal
        title={
          <div style={{ textAlign: "center", fontSize: "18px" }}>
            Two-Factor Authentication
          </div>
        }
        open={is2FAModalOpen}
        footer={null}
        closable={false}
        maskClosable={false}
        centered
        width={350}
      >
        <div style={{ textAlign: "center", padding: "10px 0" }}>
          <p style={{ color: "#555", marginBottom: "20px" }}>
            Enter the 6-digit code from your Google Authenticator app to
            continue.
          </p>
          <Input
            placeholder="000000"
            size="large"
            maxLength={6}
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            style={{
              letterSpacing: "4px",
              textAlign: "center",
              fontSize: "24px",
              marginBottom: "20px",
              height: "50px",
            }}
          />
          <Button
            type="primary"
            block
            size="large"
            style={{
              backgroundColor: "#252A4D",
              height: "45px",
              fontWeight: "bold",
            }}
            onClick={handle2FASubmit}
            loading={isVerifying2FALogin}
            disabled={otpCode.length !== 6}
          >
            Verify & Login
          </Button>
          <Button
            type="link"
            style={{ marginTop: "10px", color: "#888" }}
            onClick={() => {
              setIs2FAModalOpen(false);
              setOtpCode("");
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
}
